import { render, staticRenderFns } from "./AmazonImport.vue?vue&type=template&id=9ebd02e0&"
import script from "./AmazonImport.vue?vue&type=script&lang=js&"
export * from "./AmazonImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports